const graphData ={
    "cells": [
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "55503d58-9487-4bde-9db8-d4324a5f4df1",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "22ed75ef-26b1-4b67-b3fd-b1b4da1cd1f2",
                "port": "187d0aea-d5ba-40c5-a3eb-e600e290d729"
            },
            "target": {
                "cell": "85f9acaa-6453-4634-95e2-053d51b7da37",
                "port": "04cb671d-98f8-4915-acc8-329cde83be1e"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "07ee70ca-024f-4bfa-aacd-1229cb2fd572",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "c12f4569-92a6-4825-8ef3-d09e773e73d8",
                "port": "658f380b-1bbd-4716-bc9e-70361dde459e"
            },
            "target": {
                "cell": "2c883ab9-0dad-4e7d-9399-cc777e300162",
                "port": "f5586262-428a-4e19-b580-4ec24b6f5f58"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "73af7725-55ea-4988-b278-7894622aed53",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "2c883ab9-0dad-4e7d-9399-cc777e300162",
                "port": "1aa90edd-b933-4e17-8a0c-eee98cd0ae45"
            },
            "target": {
                "cell": "292ad085-08b9-4640-bfb3-3d4231c372d2",
                "port": "dbebb757-ea4e-49ef-963b-2aa955fddbaa"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "7d7f745e-b5af-41e0-963e-d686926fbbd1",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "292ad085-08b9-4640-bfb3-3d4231c372d2",
                "port": "6bfd9165-39b4-4ad7-8ea7-12d549be5dbe"
            },
            "target": {
                "cell": "22ed75ef-26b1-4b67-b3fd-b1b4da1cd1f2",
                "port": "cf158ec0-5e01-4ca6-8579-ed642e4c86a0"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "835ee5ef-11cf-4220-aa34-93de296843e7",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "cc702f02-46cf-43c9-a76b-94b6aa1f4394",
                "port": "1fdafcbe-8a46-4b31-acd0-45d741005350"
            },
            "target": {
                "cell": "9e42d839-c3d7-4f4c-a98f-8b666cf7028f",
                "port": "464023b8-9bd9-4e0f-8ede-524688101057"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "4edbfc09-cecb-4a59-bdec-29095a75b982",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "df706db1-9d4a-46c5-aab3-bd99c37fae4c",
                "port": "6ee00fd7-491a-4147-88b4-b53240e713c0"
            },
            "target": {
                "cell": "cc702f02-46cf-43c9-a76b-94b6aa1f4394",
                "port": "58017881-ee12-454f-a696-cb53af358f22"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "11837035-f743-4658-a4e6-5d828ff982aa",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "6b8659c3-62b3-4d68-8e39-1bbf0c51e485",
                "port": "1fdafcbe-8a46-4b31-acd0-45d741005350"
            },
            "target": {
                "cell": "df706db1-9d4a-46c5-aab3-bd99c37fae4c",
                "port": "0363c3f0-10f6-4038-9620-8e4acbd9ac51"
            }
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "c338e128-a274-45d3-973f-0812ff2f0a68",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 0,
            "source": {
                "cell": "017e0497-77b4-4c15-a645-641bdadd4d43",
                "port": "16306f90-e778-4d44-a9ce-a324fb51af32"
            },
            "target": {
                "cell": "6b8659c3-62b3-4d68-8e39-1bbf0c51e485",
                "port": "58017881-ee12-454f-a696-cb53af358f22"
            }
        },
        {
            "position": {
                "x": 113,
                "y": 316
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "开始：",
                        "text_hint": "固定元素"
                    }
                },
                "regex": {
                    "type": "Caret"
                },
                "title": {
                    "text": "以...开始",
                    "text_hint": "查找以什么开始的字符串，可以拉入其他元素，比如字符串 abc，则为查找 abc 开头的字符串。"
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "65b585d2-c1b2-43ac-9222-77373fe30b6a"
                    },
                    {
                        "group": "right",
                        "id": "658f380b-1bbd-4716-bc9e-70361dde459e"
                    },
                    {
                        "group": "bottom",
                        "id": "8f4cbecc-ae66-410f-9faf-847d2eb35bec"
                    },
                    {
                        "group": "left",
                        "id": "1d70c48c-f8df-4af3-bae7-bc9ecfcc82bb"
                    }
                ]
            },
            "id": "c12f4569-92a6-4825-8ef3-d09e773e73d8",
            "zIndex": 33
        },
        {
            "position": {
                "x": 235,
                "y": 277
            },
            "size": {
                "width": 150,
                "height": 110
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": "多个字符"
                },
                "regex": {
                    "type": "Include"
                },
                "title": {
                    "text": "包含字符",
                    "text_hint": "包含会将字符串分解为单字符，如果需要包含整个字符串，请使用\"分组\"元素。"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "1f595a66-36c4-4de0-bd0a-66d0e0a9f652"
                    },
                    {
                        "group": "right",
                        "id": "1aa90edd-b933-4e17-8a0c-eee98cd0ae45"
                    },
                    {
                        "group": "bottom",
                        "id": "f98cf09f-33a1-46fa-b9e0-abbece657f17"
                    },
                    {
                        "group": "left",
                        "id": "f5586262-428a-4e19-b580-4ec24b6f5f58"
                    }
                ]
            },
            "id": "2c883ab9-0dad-4e7d-9399-cc777e300162",
            "data": {
                "parent": true
            },
            "zIndex": 34,
            "children": [
                "0a5306bc-4b86-425f-81e4-1ba9d92f98cb"
            ]
        },
        {
            "position": {
                "x": 265,
                "y": 316
            },
            "size": {
                "width": 90,
                "height": 50
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": ""
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "Seq"
                },
                "title": {
                    "text": "字符序列",
                    "text_hint": "字符序列，包含数字序列（参数0到9），字母序列（参数a到z，或者A到Z），比如填写5到9，则表示5，6，7，8，9。注意：序列只能用在‘包含字符’或‘不包含字符’元素中。"
                },
                "params": {
                    "start": "0",
                    "end": "9"
                }
            },
            "shape": "flow-chart-title-param-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "ed5979dd-3e58-4564-a948-a3308b5dbaa9"
                    },
                    {
                        "group": "right",
                        "id": "65b5775f-d2d3-4654-9055-dd0f7db9db1e"
                    },
                    {
                        "group": "bottom",
                        "id": "ac7251eb-2d1c-4c9b-98cb-8b05f874175e"
                    },
                    {
                        "group": "left",
                        "id": "a04ea73e-3f4c-4382-a06b-2c4600686125"
                    }
                ]
            },
            "id": "0a5306bc-4b86-425f-81e4-1ba9d92f98cb",
            "zIndex": 35,
            "parent": "2c883ab9-0dad-4e7d-9399-cc777e300162"
        },
        {
            "position": {
                "x": 455,
                "y": 282
            },
            "size": {
                "width": 130,
                "height": 100
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": "字符串内容"
                },
                "regex": {
                    "type": "Repeat"
                },
                "title": {
                    "text": "重复",
                    "text_hint": "元素重复多少次，比如字符串abc重复1到3次，注意需要填写：重复最小次数和重复最大次数。"
                },
                "params": {
                    "hint1": "重复最小次数",
                    "hint2": "重复最大次数",
                    "min": "1",
                    "max": "8"
                }
            },
            "shape": "flow-chart-title-param-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "fa9dcf88-4ecc-44ef-8c4b-4366306e18a3"
                    },
                    {
                        "group": "right",
                        "id": "6bfd9165-39b4-4ad7-8ea7-12d549be5dbe"
                    },
                    {
                        "group": "bottom",
                        "id": "cc091be8-04e4-4053-831b-7cd481620675"
                    },
                    {
                        "group": "left",
                        "id": "dbebb757-ea4e-49ef-963b-2aa955fddbaa"
                    }
                ]
            },
            "id": "292ad085-08b9-4640-bfb3-3d4231c372d2",
            "data": {
                "parent": true
            },
            "zIndex": 36,
            "children": [
                "887e109c-c5fe-4ed1-ae4c-26f446e2f715"
            ]
        },
        {
            "position": {
                "x": 480,
                "y": 331.9999999999999
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "任何字符",
                        "text_hint": "固定元素"
                    }
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "X"
                },
                "title": {
                    "text": "任何字符",
                    "text_hint": "代表任何字符，即什么字符都可以。"
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "babc2d77-ad04-47ad-9a9d-e74d0d75405f"
                    },
                    {
                        "group": "right",
                        "id": "86e179dc-2979-4611-b13f-cf2c5d809ab0"
                    },
                    {
                        "group": "bottom",
                        "id": "69543b3f-6415-4a38-826d-68a8dd8fa16e"
                    },
                    {
                        "group": "left",
                        "id": "cc431f40-db09-4e96-b70c-744070d211ce"
                    }
                ]
            },
            "id": "887e109c-c5fe-4ed1-ae4c-26f446e2f715",
            "zIndex": 37,
            "parent": "292ad085-08b9-4640-bfb3-3d4231c372d2"
        },
        {
            "position": {
                "x": 630,
                "y": 277
            },
            "size": {
                "width": 150,
                "height": 110
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": "多个字符"
                },
                "regex": {
                    "type": "Exclude"
                },
                "title": {
                    "text": "不包含字符",
                    "text_hint": "比如不包含序列a到f（小写字母）。不包含会将字符串分解为单字符。"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "db53ae91-c2d3-4a51-a944-48729be89411"
                    },
                    {
                        "group": "right",
                        "id": "187d0aea-d5ba-40c5-a3eb-e600e290d729"
                    },
                    {
                        "group": "bottom",
                        "id": "cf4a18dc-00d3-4b85-a627-6b7e4779a44d"
                    },
                    {
                        "group": "left",
                        "id": "cf158ec0-5e01-4ca6-8579-ed642e4c86a0"
                    }
                ]
            },
            "id": "22ed75ef-26b1-4b67-b3fd-b1b4da1cd1f2",
            "data": {
                "parent": true
            },
            "zIndex": 38,
            "children": [
                "2d29ea69-fe15-4e77-805b-a86360764d0f"
            ]
        },
        {
            "position": {
                "x": 660,
                "y": 316
            },
            "size": {
                "width": 90,
                "height": 50
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": ""
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "Seq"
                },
                "title": {
                    "text": "字符序列",
                    "text_hint": "字符序列，包含数字序列（参数0到9），字母序列（参数a到z，或者A到Z），比如填写5到9，则表示5，6，7，8，9。注意：序列只能用在‘包含字符’或‘不包含字符’元素中。"
                },
                "params": {
                    "start": "a",
                    "end": "z"
                }
            },
            "shape": "flow-chart-title-param-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "ed5979dd-3e58-4564-a948-a3308b5dbaa9"
                    },
                    {
                        "group": "right",
                        "id": "65b5775f-d2d3-4654-9055-dd0f7db9db1e"
                    },
                    {
                        "group": "bottom",
                        "id": "ac7251eb-2d1c-4c9b-98cb-8b05f874175e"
                    },
                    {
                        "group": "left",
                        "id": "a04ea73e-3f4c-4382-a06b-2c4600686125"
                    }
                ]
            },
            "id": "2d29ea69-fe15-4e77-805b-a86360764d0f",
            "zIndex": 39,
            "parent": "22ed75ef-26b1-4b67-b3fd-b1b4da1cd1f2"
        },
        {
            "position": {
                "x": 861,
                "y": 316
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "：结尾",
                        "text_hint": "固定元素"
                    }
                },
                "regex": {
                    "type": "Dollar"
                },
                "title": {
                    "text": "以...结尾",
                    "text_hint": "查找以什么结尾的字符串，可以拉入其他元素，比如拉入字符串 xyz，则为查找 xyz 结尾的字符串。"
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "b0953fe9-13cd-4f69-96ac-41cb0aa8563a"
                    },
                    {
                        "group": "right",
                        "id": "6dfbcfa0-27c3-4999-892e-079701731660"
                    },
                    {
                        "group": "bottom",
                        "id": "81987402-29bb-4577-a898-70ea7ce9e3c2"
                    },
                    {
                        "group": "left",
                        "id": "04cb671d-98f8-4915-acc8-329cde83be1e"
                    }
                ]
            },
            "id": "85f9acaa-6453-4634-95e2-053d51b7da37",
            "zIndex": 40
        },
        {
            "position": {
                "x": 275,
                "y": 471.00000000000034
            },
            "size": {
                "width": 470,
                "height": 140
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": "字符串内容"
                },
                "regex": {
                    "type": "Group"
                },
                "title": {
                    "text": "分组",
                    "text_hint": "将各个单一的字符组合在一起"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "8db6a779-ce5b-4d02-842b-d79e78e5ddfc"
                    },
                    {
                        "group": "right",
                        "id": "66a69cdc-4091-44ef-ab37-927b42de4c8a"
                    },
                    {
                        "group": "bottom",
                        "id": "cd06805d-09b5-487d-b6dd-88f9d76192bc"
                    },
                    {
                        "group": "left",
                        "id": "d5af5456-56fc-4013-b519-3a14170a58e2"
                    }
                ]
            },
            "id": "dd355e29-e4c2-43d6-ae62-90f5ebc06919",
            "data": {
                "parent": true
            },
            "zIndex": 41,
            "children": [
                "8cb33c1f-dff6-4a8f-9353-7d23f8ac886b",
                "0f8352a6-ffa8-469d-89cd-254e4430aa57",
                "39792cc9-3dd6-48e2-b2a1-892268d5901b",
                "a4851b05-8ecb-47e6-a53d-b3e0a268b94a",
                "654c07cd-b8ad-4e1a-a53c-5002c1ca2a9f"
            ]
        },
        {
            "position": {
                "x": 455,
                "y": 521
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "olllo",
                    "text_hint": "字符串内容"
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "String"
                },
                "title": {
                    "text": "字符串",
                    "text_hint": "填写你要查找的字符串"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "eced0dd7-326a-4e3e-b3f5-3c0e0c63317e"
                    },
                    {
                        "group": "right",
                        "id": "d4e2f52a-5051-45e2-b6aa-331c4d573edd"
                    },
                    {
                        "group": "bottom",
                        "id": "02637ff4-bc94-4354-a009-c6533606a03a"
                    },
                    {
                        "group": "left",
                        "id": "2dfd0307-2204-4310-a332-734ab16c2f05"
                    }
                ]
            },
            "id": "8cb33c1f-dff6-4a8f-9353-7d23f8ac886b",
            "zIndex": 43,
            "parent": "dd355e29-e4c2-43d6-ae62-90f5ebc06919"
        },
        {
            "position": {
                "x": 300,
                "y": 521
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "www.",
                    "text_hint": "字符串内容"
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "OneOrZero"
                },
                "title": {
                    "text": "1次或0次",
                    "text_hint": "元素重复1次或0次，比如字符串abc重复0次或1次。"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "88b7aa7e-efad-4e57-9d5f-e9f43ffb095e"
                    },
                    {
                        "group": "right",
                        "id": "ba5a1342-5562-4f5d-b080-e10572b78352"
                    },
                    {
                        "group": "bottom",
                        "id": "cb4a4a18-82b3-444b-98ae-af32f8dc25e6"
                    },
                    {
                        "group": "left",
                        "id": "6102730e-76f8-4289-9a02-ee38f2e9edb6"
                    }
                ]
            },
            "id": "0f8352a6-ffa8-469d-89cd-254e4430aa57",
            "data": {
                "parent": true
            },
            "zIndex": 44,
            "parent": "dd355e29-e4c2-43d6-ae62-90f5ebc06919"
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "654c07cd-b8ad-4e1a-a53c-5002c1ca2a9f",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 46,
            "parent": "dd355e29-e4c2-43d6-ae62-90f5ebc06919",
            "source": {
                "cell": "0f8352a6-ffa8-469d-89cd-254e4430aa57",
                "port": "ba5a1342-5562-4f5d-b080-e10572b78352"
            },
            "target": {
                "cell": "8cb33c1f-dff6-4a8f-9353-7d23f8ac886b",
                "port": "2dfd0307-2204-4310-a332-734ab16c2f05"
            }
        },
        {
            "position": {
                "x": 617,
                "y": 521
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": ".top",
                    "text_hint": "字符串内容"
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "String"
                },
                "title": {
                    "text": "字符串",
                    "text_hint": "填写你要查找的字符串"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "eced0dd7-326a-4e3e-b3f5-3c0e0c63317e"
                    },
                    {
                        "group": "right",
                        "id": "d4e2f52a-5051-45e2-b6aa-331c4d573edd"
                    },
                    {
                        "group": "bottom",
                        "id": "02637ff4-bc94-4354-a009-c6533606a03a"
                    },
                    {
                        "group": "left",
                        "id": "2dfd0307-2204-4310-a332-734ab16c2f05"
                    }
                ]
            },
            "id": "39792cc9-3dd6-48e2-b2a1-892268d5901b",
            "zIndex": 47,
            "parent": "dd355e29-e4c2-43d6-ae62-90f5ebc06919"
        },
        {
            "shape": "edge",
            "attrs": {
                "line": {
                    "stroke": "#5F95FF",
                    "strokeWidth": 1,
                    "targetMarker": {
                        "name": "classic",
                        "size": 8,
                        "width": 8,
                        "height": 8
                    }
                },
                "regex": {
                    "type": "join"
                }
            },
            "id": "a4851b05-8ecb-47e6-a53d-b3e0a268b94a",
            "router": {
                "name": "manhattan"
            },
            "zIndex": 48,
            "parent": "dd355e29-e4c2-43d6-ae62-90f5ebc06919",
            "source": {
                "cell": "8cb33c1f-dff6-4a8f-9353-7d23f8ac886b",
                "port": "d4e2f52a-5051-45e2-b6aa-331c4d573edd"
            },
            "target": {
                "cell": "39792cc9-3dd6-48e2-b2a1-892268d5901b",
                "port": "2dfd0307-2204-4310-a332-734ab16c2f05"
            }
        },
        {
            "position": {
                "x": 113,
                "y": 117
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "开始：",
                        "text_hint": "固定元素"
                    }
                },
                "regex": {
                    "type": "Caret"
                },
                "title": {
                    "text": "以...开始",
                    "text_hint": "查找以什么开始的字符串，可以拉入其他元素，比如字符串 abc，则为查找 abc 开头的字符串。"
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "dde09e92-747e-498a-a8d7-cc12cf675a5b"
                    },
                    {
                        "group": "right",
                        "id": "16306f90-e778-4d44-a9ce-a324fb51af32"
                    },
                    {
                        "group": "bottom",
                        "id": "f198f7e2-d817-4835-9efb-a541b707a96e"
                    },
                    {
                        "group": "left",
                        "id": "2a94c5d8-df5b-4e99-ba16-fba4a1f36ed8"
                    }
                ]
            },
            "id": "017e0497-77b4-4c15-a645-641bdadd4d43",
            "zIndex": 49
        },
        {
            "position": {
                "x": 275,
                "y": 99
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "regex",
                    "text_hint": "字符串内容"
                },
                "regex": {
                    "type": "String_Group"
                },
                "title": {
                    "text": "字符串组",
                    "text_hint": "字符串组是字符串元素和分组元素的组合。"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "8b2922d5-a76a-4c84-b098-7d21d8357862"
                    },
                    {
                        "group": "right",
                        "id": "1fdafcbe-8a46-4b31-acd0-45d741005350"
                    },
                    {
                        "group": "bottom",
                        "id": "b0228b07-2274-4761-9913-3bba36f92bd1"
                    },
                    {
                        "group": "left",
                        "id": "58017881-ee12-454f-a696-cb53af358f22"
                    }
                ]
            },
            "id": "6b8659c3-62b3-4d68-8e39-1bbf0c51e485",
            "zIndex": 50
        },
        {
            "position": {
                "x": 440,
                "y": 88
            },
            "size": {
                "width": 100,
                "height": 90
            },
            "attrs": {
                "text": {
                    "text": "",
                    "text_hint": "字符串内容"
                },
                "regex": {
                    "type": "ZeroOrMore"
                },
                "title": {
                    "text": "0次或多次",
                    "text_hint": "元素重复0次以上（包括0次），比如字符串abc重复0到无限次。"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "23e28cf9-9fa8-40e9-9e58-44c2bfc95f6d"
                    },
                    {
                        "group": "right",
                        "id": "6ee00fd7-491a-4147-88b4-b53240e713c0"
                    },
                    {
                        "group": "bottom",
                        "id": "38dfe985-b6a9-4c39-882f-01384d7ccb8c"
                    },
                    {
                        "group": "left",
                        "id": "0363c3f0-10f6-4038-9620-8e4acbd9ac51"
                    }
                ]
            },
            "id": "df706db1-9d4a-46c5-aab3-bd99c37fae4c",
            "data": {
                "parent": true
            },
            "zIndex": 51,
            "children": [
                "979b0ddd-5541-45e6-b373-1eac1139397c"
            ]
        },
        {
            "position": {
                "x": 617,
                "y": 99
            },
            "size": {
                "width": 100,
                "height": 68
            },
            "attrs": {
                "text": {
                    "text": "olllo.top",
                    "text_hint": "字符串内容"
                },
                "regex": {
                    "type": "String_Group"
                },
                "title": {
                    "text": "字符串组",
                    "text_hint": "字符串组是字符串元素和分组元素的组合。"
                }
            },
            "shape": "flow-chart-title-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "8b2922d5-a76a-4c84-b098-7d21d8357862"
                    },
                    {
                        "group": "right",
                        "id": "1fdafcbe-8a46-4b31-acd0-45d741005350"
                    },
                    {
                        "group": "bottom",
                        "id": "b0228b07-2274-4761-9913-3bba36f92bd1"
                    },
                    {
                        "group": "left",
                        "id": "58017881-ee12-454f-a696-cb53af358f22"
                    }
                ]
            },
            "id": "cc702f02-46cf-43c9-a76b-94b6aa1f4394",
            "zIndex": 52
        },
        {
            "position": {
                "x": 791,
                "y": 117
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "：结尾",
                        "text_hint": "固定元素"
                    }
                },
                "regex": {
                    "type": "Dollar"
                },
                "title": {
                    "text": "以...结尾",
                    "text_hint": "查找以什么结尾的字符串，可以拉入其他元素，比如拉入字符串 xyz，则为查找 xyz 结尾的字符串。"
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "a25ce846-7818-46d1-8e07-0b6e20b6e867"
                    },
                    {
                        "group": "right",
                        "id": "b195d6d2-9b84-49e8-b4b8-2cf482324f81"
                    },
                    {
                        "group": "bottom",
                        "id": "fda4b496-f35d-44c6-9a22-1060ff79148e"
                    },
                    {
                        "group": "left",
                        "id": "464023b8-9bd9-4e0f-8ede-524688101057"
                    }
                ]
            },
            "id": "9e42d839-c3d7-4f4c-a98f-8b666cf7028f",
            "zIndex": 53
        },
        {
            "position": {
                "x": 455,
                "y": 128
            },
            "size": {
                "width": 70,
                "height": 32
            },
            "attrs": {
                "text": {
                    "textWrap": {
                        "text": "任何字符",
                        "text_hint": "固定元素"
                    }
                },
                "body": {
                    "stroke": "#73d13d"
                },
                "regex": {
                    "type": "X"
                },
                "title": {
                    "text": "任何字符",
                    "text_hint": "代表任何字符，即什么字符都可以。"
                }
            },
            "shape": "flow-chart-rect",
            "ports": {
                "groups": {
                    "top": {
                        "position": "top",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "right": {
                        "position": "right",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "bottom": {
                        "position": "bottom",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    },
                    "left": {
                        "position": "left",
                        "attrs": {
                            "circle": {
                                "r": 3,
                                "magnet": true,
                                "stroke": "#5F95FF",
                                "strokeWidth": 1,
                                "fill": "#fff",
                                "style": {
                                    "visibility": "hidden"
                                }
                            }
                        }
                    }
                },
                "items": [
                    {
                        "group": "top",
                        "id": "f2c45138-7786-4a0a-aa52-f36525a447f3"
                    },
                    {
                        "group": "right",
                        "id": "a23dbe3b-5cce-4e47-ab4b-fed175b76764"
                    },
                    {
                        "group": "bottom",
                        "id": "ef32ef85-0451-40e3-afc0-4d0c2d98dbf4"
                    },
                    {
                        "group": "left",
                        "id": "fcd3c7ea-93cf-4e28-ab45-c3764114beae"
                    }
                ]
            },
            "id": "979b0ddd-5541-45e6-b373-1eac1139397c",
            "zIndex": 54,
            "parent": "df706db1-9d4a-46c5-aab3-bd99c37fae4c"
        }
    ]
}
export default graphData
